export const imageResize = (size: string, url: string) => {
  // return `https://core-thumbnails-service.tripster.ru/unsafe/${size}/${url}`;
  return url;
};
